import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import i18n from "./i18n";
import {singularSdk, SingularConfig} from "singular-sdk";
import { getMetaplayApp } from './MetaplayApp.ts'

const options = {
    projectName: 'behemoth',
    accountApiUrl: process.env.REACT_APP_AUTH_BASE_URL + "/selfServe",
    gameServerUrl: process.env.REACT_APP_GAME_SERVER_BASE_URL,
    environment: process.env.REACT_APP_ENVIRONMENT_NAME,
}

export const metaplayApp = getMetaplayApp()
metaplayApp.initialize(options)

const singularConfig = new SingularConfig(process.env.REACT_APP_SINGULAR_KEY, process.env.REACT_APP_SINGULAR_SECRET, process.env.REACT_APP_SINGULAR_PRODUCTID);
singularSdk.init(singularConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
